import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient , HttpHeaders, HttpParams} from '@angular/common/http';
import { AppConfig } from '../config/config';
@Injectable({
  providedIn: 'root'
})
export class AgencyService {
  API_BASE_URL: any = AppConfig.API_BASE_URL;

  constructor(private http: HttpClient) { }

  listAgency(token:any) {
    //const url = this.API_BASE_URL + '/getSingleUserData';
    
    const url =  AppConfig.API_BASE_URL +'/getAgencies';

    const headers = new HttpHeaders({
    //  'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer '+token
    });
    const options = { headers: headers };

    const body = {
      // 'pageNo' : pageNo,
      // 'size' : size
    };

    
    return this.http.post(url, body, options);
  }

  listUserType(token:any) {
    //const url = this.API_BASE_URL + '/getSingleUserData';
    
    const url = AppConfig.API_BASE_URL+'user/listusertype';

    const headers = new HttpHeaders({
    //  'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer '+token
    });
    const options = { headers: headers };

    const body = {
      // 'pageNo' : pageNo,
      // 'size' : size
    };

    
    return this.http.post(url, body, options);
  }




  listSingleAgency(token:any,agencyRefId:any){

 //const url = this.API_BASE_URL + '/getSingleUserData';
    
 const url = AppConfig.API_BASE_URL + 'user/getUsersByAgency';

 const headers = new HttpHeaders({
  // 'Content-Type': 'application/x-www-form-urlencoded',
   'authorization': 'Bearer '+token
 });
 const options = { headers: headers };

 const body = {
  agencyRefId:agencyRefId
 };

 
 return this.http.post(url, body, options);
  }

  addStaff(token:any,formData:any){

    //const url = this.API_BASE_URL + '/getSingleUserData';
       
    const url = AppConfig.API_BASE_URL + 'user/createAdmin';
   
    const headers = new HttpHeaders({
     // 'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer '+token
    });
    const options = { headers: headers };
   
    const body = formData
    return this.http.post(url, body, options);
     }
   

     
  updateStaff(token:any,formData:any){

    //const url = this.API_BASE_URL + '/getSingleUserData';
       
    const url = AppConfig.API_BASE_URL + 'user/updateUser';
   
    const headers = new HttpHeaders({
     // 'Content-Type': 'application/x-www-form-urlencoded',
      'authorization': 'Bearer '+token
    });
    const options = { headers: headers };
   
    const body = formData
    return this.http.post(url, body, options);
     }

     addAgency(token:any,formData:any){

      //const url = this.API_BASE_URL + '/getSingleUserData';
         
      const url = AppConfig.API_BASE_URL + '/addAgency';
     
      const headers = new HttpHeaders({
       // 'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer '+token
      });
      const options = { headers: headers };
     
      const body = formData
      return this.http.post(url, body, options);
       }
   
       
       updateAgency(token:any,formData:any){

        //const url = this.API_BASE_URL + '/getSingleUserData';
           
        const url = AppConfig.API_BASE_URL + '/updateAgency';
       
        const headers = new HttpHeaders({
         // 'Content-Type': 'application/x-www-form-urlencoded',
          'authorization': 'Bearer '+token
        });
        const options = { headers: headers };
       
        const body = formData
        return this.http.post(url, body, options);
         }
     

         disableAgency(token:any,agencyId:any){

          //const url = this.API_BASE_URL + '/getSingleUserData';
             
          const url = AppConfig.API_BASE_URL + '/updateUser';
         
          const headers = new HttpHeaders({
           // 'Content-Type': 'application/x-www-form-urlencoded',
            'authorization': 'Bearer '+token
          });
          const options = { headers: headers };
         
          const body = {
            agencyId:agencyId
          }
          return this.http.post(url, body, options);
           }
       
         

     UploadSingle(image:File,token:any){
  
        const url = this.API_BASE_URL + '/uploadFile';
      
        var formData = new FormData();
      
        formData.append('file',image, image.name);
        
        const headers = new HttpHeaders({
      
          'authorization': 'Bearer '+token
        });
        headers.append('Content-Type', 'multipart/form-data');
        const options = { headers: headers };
        return this.http.post(url,formData,options);
      }
     
   

}
